import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'company/autocomplete';

interface EndpointParams {
	fragment: string;
	pageSize: number;
	enforcePageSize?: boolean;
}

export function useCompanyAutocomplete({
	enabled,
	fragment,
	pageSize,
	enforcePageSize = true,
}: {
	enabled?: boolean;
} & EndpointParams) {
	const userSession = useUserSession();
	return useInfiniteQuery({
		enabled,
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.ICompany>>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: {
						enforcePageSize,
						fragment,
						pageSize,
						pageToken: pageParam,
					},
					urlPath: 'company/autocomplete',
				}),
				'GET'
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		queryKey: [BASE_QUERY_KEY, fragment, pageSize, enforcePageSize],
		initialPageParam: '',
	});
}
